import { twMerge } from 'tailwind-merge';
import {
  default as MuiTableCell,
  type TableCellProps as MuiTableCellProps,
} from '@mui/material/TableCell';
import type { SortOrder } from '@witmetrics/utils';
import { DESCENDING } from '@witmetrics/utils/constants';
import { AscendingIcon, DescendingIcon } from '@/icons';
import { classes } from './utils';

export interface SortableHeadCellProps extends MuiTableCellProps {
  className?: string;
  sortOrder: SortOrder | null;
  onSort: () => void;
}

export default function SortableHeadCell({
  className,
  sortOrder,
  onSort,
  children,
}: SortableHeadCellProps) {
  const renderChevron = () => {
    return sortOrder === DESCENDING ? (
      <DescendingIcon className={classes.chevron} fontSize="small" />
    ) : (
      <AscendingIcon className={classes.chevron} fontSize="small" />
    );
  };

  return (
    <MuiTableCell
      className={twMerge(classes.cell, className)}
      onClick={() => onSort()}>
      <div className={classes.content}>
        <label className={classes.label}>{children}</label>
        {sortOrder !== null && renderChevron()}
      </div>
    </MuiTableCell>
  );
}
